import styled from 'styled-components'

export const FiltersWrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;